<template>
	<cycle class="library-showcase" :config="config">
		<slot />
	</cycle>
</template>

<script>

	import Cycle from "@/components/Cycle"

	export default {
		name: "libraryShowcase",
		components: { Cycle },
		data () {
			return {
				config: {
					fx: "carousel",
					speed: 10000,
					timeout: 1,
					easing: "linear"
				}
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "list-style-reset";
	@import "media";

	$horzRatio: 2.4;
	$margin: 3rem;

	.library-showcase {
		@include list-style-reset;
		display:flex;
		/deep/ {
			li {
				margin:0 #{$margin / $horzRatio};
				figure + figure {
					margin-top:$margin;
					transform:translateX(-50%);
				}
				img {
					display:block;
					@include media(small,large) {
						width:190px;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/LibraryShowcase.vue